import { OpenAPI } from "simplydo/interfaces";

import { canEditIdea, hasPermission } from "./permissions";

export const shouldShowIdeaSection = (
  idea:
    | OpenAPI.Assign<
        OpenAPI.Schemas["Idea"],
        OpenAPI.Schemas["AssignIdeaTemplates"]
      >
    | undefined,
  section: NonNullable<OpenAPI.Schemas["IdeaTemplate"]["body"]>[number],
) => {
  if (!idea || !section) return false;

  if (section.type === "assessment") {
    return idea.ownerIdeaTemplate.assessmentEnabled;
  }

  return (
    section.fields?.length > 0 ||
    section.type === "businessProfile" ||
    section.type === "impact" ||
    section.type === "edi"
  );
};

export const shouldShowIdeaEdiSection = (
  user: OpenAPI.Schemas["User"] | undefined,
  idea:
    | OpenAPI.Assign<
        OpenAPI.Schemas["Idea"],
        OpenAPI.Schemas["AssignIdeaTemplates"],
        OpenAPI.Schemas["AssignIdeaChallenges"]
      >
    | undefined,
  section: NonNullable<OpenAPI.Schemas["IdeaTemplate"]["body"]>[number],
) => {
  if (!idea || !section) return false;
  if (canEditIdea(user, idea)) return true;
  if (
    section.type === "edi" &&
    hasPermission(user, "org.viewEdi", idea.ownerChallenge?.organisation)
  )
    return true;
  return false;
};
